export const languageSelectorResponsiveStructure = {
  parent: 'comp-kbgajy18',
  componentType: 'wysiwyg.viewer.components.LanguageSelector',
  layout: {
    x: 0,
    fixedPosition: false,
    y: 111,
    scale: 1,
    height: 90,
    rotationInDegrees: 0,
    width: 160,
  },
  type: 'Component',
  metaData: {
    pageId: 'masterPage',
    sig: 'v5u-53',
  },
  skin: 'wysiwyg.viewer.skins.LanguageSelectorSkin',
  data: {
    type: 'LanguageSelector',
    metaData: {
      isHidden: false,
      sig: 'v5u-35',
      pageId: 'masterPage',
      schemaVersion: '1.0',
      isPreset: false,
    },
  },
  props: {
    itemFormat: 'fullLocalizedName',
    iconType: 'none',
    iconSize: 22,
    alignTabs: 'left',
    displayMode: 'dropdown',
    type: 'LanguageSelectorProperties',
    metaData: {
      schemaVersion: '1.0',
      pageId: 'masterPage',
      sig: 'v5u-39',
    },
    hasArrow: true,
    languagesOrder: [],
  },
  editorsettings: {
    type: 'EditorSettings',
    metaData: {
      isHidden: false,
      sig: 'v5u-36',
      pageId: 'masterPage',
      schemaVersion: '1.0',
      isPreset: false,
    },
  },
  scopedLayouts: {},
  layouts: {
    containerLayout: {},
    spx: {
      refWidth: 1280,
      resolverType: 'scale',
    },
    componentLayout: {
      type: 'ComponentLayout',
      width: {
        type: 'px',
        value: 166.59375,
      },
      height: {
        type: 'px',
        value: 48,
      },
      hidden: false,
    },
    itemLayout: {
      alignSelf: 'start',
      margins: {
        left: {
          type: 'spx',
          value: 0,
        },
        right: {
          type: 'spx',
          value: 0,
        },
        top: {
          type: 'spx',
          value: 22.5,
        },
        bottom: {
          type: 'spx',
          value: 0,
        },
      },
      gridArea: {
        rowStart: 1,
        rowEnd: 2,
        columnStart: 1,
        columnEnd: 2,
      },
      justifySelf: 'center',
      type: 'GridItemLayout',
    },
    type: 'SingleLayoutData',
    metaData: {
      isHidden: false,
      sig: 'v5u-37',
      pageId: 'masterPage',
      schemaVersion: '1.0',
      isPreset: false,
    },
  },
  scopedStyles: {
    'variants-ljclok8y1': {
      styleType: 'custom',
      componentClassName: 'wysiwyg.viewer.components.LanguageSelector',
      style: {
        background: {},
        groups: {},
        properties: {
          backgroundColorHover: '#C2C2C2',
          backgroundColor: '#FFFFFF',
          itemFont: 'font_8',
          'alpha-separatorColor': '0.0',
          boxShadow: '0px 1px 4px 0px rgba(0,0,0,0.6)',
          borderSides: 'none',
          itemSpacing: '5px',
          backgroundColorActive: '#C2C2C2',
          borderWidth: '1.0',
          borderRadius: '0px 0px 0px 0px',
          itemTextColor: '#000000',
          separatorColor: '#000000',
          'alpha-itemTextColorHover': '1',
          'alpha-backgroundColorActive': '0.5',
          itemTextColorHover: '#000000',
          'alpha-backgroundColorHover': '0.2',
          borderColorHover: 'rgba(32, 32, 32, 1)',
          'alpha-borderColor': '0.6',
          borderColorActive: 'rgba(32, 32, 32, 1)',
          itemTextColorActive: '#000000',
          'boxShadowToggleOn-boxShadow': 'false',
          'alpha-itemTextColor': '1',
          borderColor: '#000000',
        },
        propertiesSource: {
          backgroundColorHover: 'value',
          backgroundColor: 'value',
          itemFont: 'theme',
          'alpha-separatorColor': 'value',
          boxShadow: 'value',
          borderSides: 'value',
          itemSpacing: 'value',
          backgroundColorActive: 'value',
          borderWidth: 'value',
          borderRadius: 'value',
          itemTextColor: 'value',
          separatorColor: 'value',
          'alpha-itemTextColorHover': 'value',
          'alpha-backgroundColorActive': 'value',
          itemTextColorHover: 'value',
          'alpha-backgroundColorHover': 'value',
          borderColorHover: 'value',
          'alpha-borderColor': 'value',
          borderColorActive: 'value',
          itemTextColorActive: 'value',
          'boxShadowToggleOn-boxShadow': 'value',
          'alpha-itemTextColor': 'value',
          borderColor: 'value',
        },
        propertiesOverride: {
          itemFont: {
            fontStyle: 'normal',
            color: '#000000',
            fontFamily: 'madefor-text',
            letterSpacing: '0em',
            lineHeight: '1.6em',
            fontVariant: 'normal',
            fontSize: '16px',
            fontWeight: 'normal',
          },
        },
      },
      pageId: '',
      spx: {
        resolverType: 'scale',
        refWidth: 768,
      },
      compId: '',
      type: 'ComponentStyle',
      metaData: {
        isHidden: false,
        sig: 'v5u-41',
        pageId: 'masterPage',
        schemaVersion: '1.0',
        isPreset: false,
      },
      skin: 'wysiwyg.viewer.skins.LanguageSelectorSkin',
    },
    'variants-ljclok8y2': {
      styleType: 'custom',
      componentClassName: 'wysiwyg.viewer.components.LanguageSelector',
      style: {
        background: {},
        groups: {},
        properties: {
          backgroundColorHover: '#C2C2C2',
          backgroundColor: '#FFFFFF',
          itemFont: 'font_8',
          'alpha-separatorColor': '0.0',
          boxShadow: '0px 1px 4px 0px rgba(0,0,0,0.6)',
          borderSides: 'none',
          itemSpacing: '5px',
          backgroundColorActive: '#C2C2C2',
          borderWidth: '1.0',
          borderRadius: '0px 0px 0px 0px',
          itemTextColor: '#000000',
          separatorColor: '#000000',
          'alpha-itemTextColorHover': '1',
          'alpha-backgroundColorActive': '0.5',
          itemTextColorHover: '#000000',
          'alpha-backgroundColorHover': '0.2',
          borderColorHover: 'rgba(32, 32, 32, 1)',
          'alpha-borderColor': '0.6',
          borderColorActive: 'rgba(32, 32, 32, 1)',
          itemTextColorActive: '#000000',
          'boxShadowToggleOn-boxShadow': 'false',
          'alpha-itemTextColor': '1',
          borderColor: '#000000',
        },
        propertiesSource: {
          backgroundColorHover: 'value',
          backgroundColor: 'value',
          itemFont: 'theme',
          'alpha-separatorColor': 'value',
          boxShadow: 'value',
          borderSides: 'value',
          itemSpacing: 'value',
          backgroundColorActive: 'value',
          borderWidth: 'value',
          borderRadius: 'value',
          itemTextColor: 'value',
          separatorColor: 'value',
          'alpha-itemTextColorHover': 'value',
          'alpha-backgroundColorActive': 'value',
          itemTextColorHover: 'value',
          'alpha-backgroundColorHover': 'value',
          borderColorHover: 'value',
          'alpha-borderColor': 'value',
          borderColorActive: 'value',
          itemTextColorActive: 'value',
          'boxShadowToggleOn-boxShadow': 'value',
          'alpha-itemTextColor': 'value',
          borderColor: 'value',
        },
        propertiesOverride: {
          itemFont: {
            fontStyle: 'normal',
            color: '#000000',
            fontFamily: 'madefor-text',
            letterSpacing: '0em',
            lineHeight: '1.6em',
            fontVariant: 'normal',
            fontSize: '16px',
            fontWeight: 'normal',
          },
        },
      },
      pageId: '',
      spx: {
        resolverType: 'scale',
        refWidth: 390,
      },
      compId: '',
      type: 'ComponentStyle',
      metaData: {
        isHidden: false,
        sig: 'v5u-43',
        pageId: 'masterPage',
        schemaVersion: '1.0',
        isPreset: false,
      },
      skin: 'wysiwyg.viewer.skins.LanguageSelectorSkin',
    },
  },
  style: {
    styleType: 'custom',
    componentClassName: 'wysiwyg.viewer.components.LanguageSelector',
    style: {
      propertiesOverride: {
        itemFont: {
          fontStyle: 'normal',
          color: '#000000',
          fontFamily: 'madefor-text',
          letterSpacing: '0em',
          lineHeight: '1.6em',
          fontVariant: 'normal',
          fontSize: '16px',
          fontWeight: 'normal',
        },
      },
      properties: {
        backgroundColorHover: '#C2C2C2',
        backgroundColor: '#FFFFFF',
        itemFont: 'font_8',
        'alpha-separatorColor': '0.0',
        boxShadow: '0px 1px 4px 0px rgba(0,0,0,0.6)',
        borderSides: 'none',
        itemSpacing: '5px',
        backgroundColorActive: '#C2C2C2',
        borderWidth: '1.0',
        borderRadius: '0px 0px 0px 0px',
        itemTextColor: '#000000',
        separatorColor: '#000000',
        'alpha-itemTextColorHover': '1',
        'alpha-backgroundColorActive': '0.5',
        itemTextColorHover: '#000000',
        'alpha-backgroundColorHover': '0.2',
        borderColorHover: 'rgba(32, 32, 32, 1)',
        'alpha-borderColor': '0.6',
        borderColorActive: 'rgba(32, 32, 32, 1)',
        itemTextColorActive: '#000000',
        'boxShadowToggleOn-boxShadow': 'false',
        'alpha-itemTextColor': '1',
        borderColor: '#000000',
      },
      propertiesSource: {
        backgroundColorHover: 'value',
        backgroundColor: 'value',
        itemFont: 'theme',
        'alpha-separatorColor': 'value',
        boxShadow: 'value',
        borderSides: 'value',
        itemSpacing: 'value',
        backgroundColorActive: 'value',
        borderWidth: 'value',
        borderRadius: 'value',
        itemTextColor: 'value',
        separatorColor: 'value',
        'alpha-itemTextColorHover': 'value',
        'alpha-backgroundColorActive': 'value',
        itemTextColorHover: 'value',
        'alpha-backgroundColorHover': 'value',
        borderColorHover: 'value',
        'alpha-borderColor': 'value',
        borderColorActive: 'value',
        itemTextColorActive: 'value',
        'boxShadowToggleOn-boxShadow': 'value',
        'alpha-itemTextColor': 'value',
        borderColor: 'value',
      },
      groups: {},
    },
    pageId: '',
    spx: {
      resolverType: 'scale',
      refWidth: 1280,
    },
    compId: '',
    type: 'ComponentStyle',
    metaData: {
      isHidden: false,
      sig: 'v5u-40',
      pageId: 'masterPage',
      schemaVersion: '1.0',
      isPreset: false,
    },
    skin: 'wysiwyg.viewer.skins.LanguageSelectorSkin',
  },
  activeModes: {},
  referredVariants: {
    'variants-ljclok8y1': {
      pointer: {
        id: 'variants-ljclok8y1',
        type: 'variants',
        pageId: 'masterPage',
      },
      data: {
        type: 'BreakpointRange',
        id: 'variants-ljclok8y1',
        metaData: {
          isPreset: false,
          schemaVersion: '2.0',
          isHidden: false,
          sig: '4y8-2',
          pageId: 'masterPage',
        },
        min: 320,
        max: 1000,
        canvasSize: 768,
      },
    },
    'variants-ljclok8y2': {
      pointer: {
        id: 'variants-ljclok8y2',
        type: 'variants',
        pageId: 'masterPage',
      },
      data: {
        type: 'BreakpointRange',
        id: 'variants-ljclok8y2',
        metaData: {
          isPreset: false,
          schemaVersion: '2.0',
          isHidden: false,
          sig: '4y8-3',
          pageId: 'masterPage',
        },
        min: 320,
        max: 750,
        canvasSize: 390,
      },
    },
  },
  activeVariants: [],
} as any;
